<div class="container-fluid">
    <form [formGroup]="inputForm">
        <div formGroupName="inputData">

            <div class="row">
                <div class="col-md-6 mb-5" *ngIf="exerciseId">

                    <app-akit-header title="player" [enableSubHeader]="false"/>
                    <div class="mt-4">
                        <div *ngIf="refId && sessionId">
                            <app-akit-interaction [sessionId]="sessionId" [refId]="refId"/>
                        </div>
                        <div *ngIf="!refId">
                            <app-akit-exercise [exerciseId]="exerciseId" [assessmentMode]="assessmentMode"
                                (sessionCreated)="onSessionCreated($event)">
                            </app-akit-exercise>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="right-header mb-2 mb-md-5">
                        <button class="expand-button" *ngIf="!showSubheader" (click)="showSubheader=!showSubheader">
                            <span class="mx-3">Options</span>
                            <i class="fa-solid fa-caret-down"></i>
                        </button>

                        <select formControlName="viewType" class="form-control" [attr.empty]="!viewMode">
                            <option value="">Select view...</option>
                            <option value="scoring">Scoring info</option>
                            <option value="review">Review mode</option>
                            <option value="solution">Solution mode</option>
                            <option value="session">Session data</option>
                            <option value="exercise">Exercise components</option>
                        </select>
                        <button class="form-control refresh-button" (click)="refreshResults()"><i
                                class="fa-solid fa-rotate"></i></button>
                    </div>
                    <div class="sub-header" *ngIf="showSubheader">
                        <button class="close-button" (click)="showSubheader=false">
                            <i class="fa-solid fa-circle-xmark"></i>
                        </button>
                        
                        <div class="sub-header-content">
                            <div class="form-group">
                                <label for="exerciseId" class="form-label">Exercise ID</label>
                                <div class="input-group">
                                    <input id="exerciseId" formControlName="exerciseId" class="form-control"
                                        placeholder="Enter exercise ID" />
                                    <button class="btn btn-primary" (click)="createSession()">Go</button>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="theme" class="form-label">Theme</label>
                                <select id="theme" formControlName="theme" class="form-control">
                                    <option *ngFor="let t of themes" [value]="t.id">{{t.name}}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <div class="form-check">
                                    <input id="assessmentMode" formControlName="assessmentMode" type="checkbox" class="form-check-input">
                                    <label for="assessmentMode" class="form-check-label">Assessment mode</label>
                                </div>
                            </div>

                            <div class="form-group" *ngIf="assessmentMode">
                                <button class="btn btn-warning" (click)="lockSession()">
                                    <i class="fa-solid fa-lock"></i>
                                    Lock session
                                </button>
                            </div>
                        </div>
                    </div>

                    <app-akit-exercise *ngIf="sessionId && !refId && (viewMode=='review' || viewMode=='solution')"
                        [sessionId]="sessionId" [reviewMode]="viewMode=='review'" [solutionMode]="viewMode=='solution'">
                    </app-akit-exercise>
                    <app-akit-interaction *ngIf="sessionId && refId && (viewMode=='review' || viewMode=='solution')"
                        [sessionId]="sessionId" [refId]="refId" [reviewMode]="viewMode=='review'"
                        [solutionMode]="viewMode=='solution'">
                    </app-akit-interaction>
                    <div class="scoring-data" *ngIf="viewMode=='scoring' && exerciseResult!=null">
                        <app-exercise-result [exerciseResult]="exerciseResult"></app-exercise-result>
                    </div>
                    <div class="session-data" *ngIf="viewMode=='session' && sessionData!=null">
                        <ngx-json-viewer [json]="sessionData"></ngx-json-viewer>
                    </div>
                    <div class="exercise-data" *ngIf="viewMode=='exercise' && exerciseData!=null">
                        <app-exercise-data [exerciseData]="exerciseData" [activeRefId]="refId"
                            (interactionSelected)="showInteraction($event)"></app-exercise-data>
                    </div>

                </div>

            </div>
        </div>
    </form>

</div>